/* eslint-disable @stylistic/max-len */
import { FormRenderFieldEvent } from './FormRenderFieldEvent';

/**
 * An event that is fired when a field is rendered in the object form.
 * This event allow to add listener after input event is fired.
 * This event is fired for every field in the form except hidden ones.
 *
 * Existing events:
 *  * onChange - field listener after field value change
 *  * onBlur - field listener after field blur
 *  * onMount - field listener after form is mounted
 *  * onSubmit - field listener after form is submitted
 *
 * You can read more about field listeners in the [TanstackForm documentation](https://tanstack.com/form/latest/docs/framework/react/guides/listeners).
 *
 * @returns {[eventName: onChange | onBlur | onMount | onSubmit]: ({ value: any, fieldApi: any }) => void}
 *          An array containing the event name and the listener function.
 *
 * @eventName "flotiq.form.field.listeners::add"
 * @memberof FlotiqPlugins.Events
 */
export class FormFieldListenersEvent extends FormRenderFieldEvent {}
